import get from 'lodash/get';

const ADD_TO_SEARCH_PIN_FIELD = 'add_to_search_pin';

const validateSearchPhraseIds = (value, allValues) => {
    const enabled = get(allValues, ADD_TO_SEARCH_PIN_FIELD, false);

    if (!enabled || (value && value.length >= 1)) {
        return null;
    }

    return 'At least one search phrase is required';
};

export { ADD_TO_SEARCH_PIN_FIELD, validateSearchPhraseIds };
